<template>
  <!-- 客户资料 Tab（开户申请详情 / 开户审核共用）：
       申请信息、基本信息、证件信息、问卷调查、银行卡、审核信息六块，
       换一条记录（detail.id 变化）时自动回到第一个 Tab -->
  <el-tabs v-model="tab">
    <!-- 申请信息：只留开户申请自身的数据，用户ID/姓名等在「基本信息」里 -->
    <el-tab-pane label="申请信息" name="apply">
      <div class="tab-block">
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">申请编号</div><div class="di-value mono">{{ detail.pnoNo || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">客户组</div><div class="di-value">{{ groupLabel(detail.groupId) }}</div></div>
          <div class="detail-item"><div class="di-label">激活状态</div><div class="di-value">{{ detail.isActive === 2 ? '已激活' : '未激活' }}</div></div>
        </div>
      </div>
      <div class="tab-block">
        <div class="detail-sec-title">注册/登录信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">注册时间</div><div class="di-value">{{ detail.regTime || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">激活时间</div><div class="di-value">{{ detail.activateTime || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">注册IP</div><div class="di-value mono">{{ detail.regIp || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">开户来源</div><div class="di-value">{{ regLabel(detail.regWay) }}</div></div>
          <div class="detail-item"><div class="di-label">渠道</div><div class="di-value">{{ detail.channel || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">邀请人</div><div class="di-value">{{ detail.referrer || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">最后登录时间</div><div class="di-value">{{ detail.lastLoginTime || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">最后登录IP</div><div class="di-value mono">{{ detail.lastLoginIp || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">登录次数</div><div class="di-value">{{ detail.loginCount || 0 }}</div></div>
        </div>
      </div>
    </el-tab-pane>

    <!-- 基本信息 + 地址信息 -->
    <el-tab-pane label="基本信息" name="basic">
      <div class="tab-block">
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">头像</div>
            <div class="di-value">
              <img v-if="detail.avatar" :src="detail.avatar" class="avatar-circle">
              <div v-else class="avatar-circle">{{ (detail.name || '?').charAt(0) }}</div>
            </div>
          </div>
          <div class="detail-item"><div class="di-label">昵称</div><div class="di-value">{{ detail.nickName || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">用户ID</div><div class="di-value mono">{{ detail.customerNo }}</div></div>
          <div class="detail-item"><div class="di-label">姓名</div><div class="di-value">{{ detail.name || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">手机号</div><div class="di-value">{{ (detail.phonePrefix ? '+' + detail.phonePrefix + ' ' : '') + (detail.phoneNumber || '--') }}</div></div>
          <div class="detail-item"><div class="di-label">手机归属地</div><div class="di-value">{{ detail.phoneRegion || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">邮箱</div><div class="di-value">{{ detail.email || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">出生国家</div><div class="di-value">{{ countryLabel(detail.birthCountry) }}</div></div>
          <div class="detail-item"><div class="di-label">国籍</div><div class="di-value">{{ countryLabel(detail.nationality) }}</div></div>
          <div class="detail-item"><div class="di-label">居住国家</div><div class="di-value">{{ countryLabel(detail.residenceCountry) }}</div></div>
          <div class="detail-item"><div class="di-label">税务居民地</div><div class="di-value">{{ detail.taxResidence || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">税务识别号</div><div class="di-value">{{ detail.tinNumber || '--' }}</div></div>
        </div>
      </div>
      <div class="tab-block">
        <div class="detail-sec-title">地址信息</div>
        <div class="detail-grid">
          <div class="detail-item detail-span-3"><div class="di-label">居住地址</div><div class="di-value">{{ areaLabel(currentAddress) }}</div></div>
          <div class="detail-item"><div class="di-label">地址证明类型</div><div class="di-value">{{ proofTypeLabel(currentAddress && currentAddress.proofType) }}</div></div>
          <div class="detail-item"><div class="di-label">提交时间</div><div class="di-value">{{ (currentAddress && currentAddress.createDate) || detail.regTime || '--' }}</div></div>
        </div>
        <div class="thumb-row">
          <div class="thumb-cell">
            <div class="doc-thumb" @click="previewUrl(currentAddress && currentAddress.proofFileUrls, '地址证明文件')">
              <img v-if="currentAddress && currentAddress.proofFileUrls" :src="currentAddress.proofFileUrls" alt="">
              <span v-else>📄</span>
            </div>
            <div class="doc-thumb-label">地址证明文件</div>
          </div>
        </div>
      </div>
    </el-tab-pane>

    <!-- 证件信息 -->
    <el-tab-pane label="证件信息" name="idCard">
      <div class="tab-block">
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">证件类型</div><div class="di-value">{{ docTypeLabel(detail.docType) }}</div></div>
          <div class="detail-item"><div class="di-label">证件号码</div><div class="di-value mono">{{ detail.docNumber || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">证件姓名</div><div class="di-value">{{ detail.docName || detail.name || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">证件国籍</div><div class="di-value">{{ countryLabel(detail.docNationality) }}</div></div>
          <div class="detail-item"><div class="di-label">证件归属地</div><div class="di-value">{{ detail.idCardRegion || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">有效期</div><div class="di-value">{{ detail.validFrom || '--' }} 至 {{ detail.validTo || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">认证状态</div>
            <div class="di-value" :style="{color: docStatusColor(detail.docStatus)}">{{ docStatusLabel(detail.docStatus) }}</div></div>
          <div class="detail-item"><div class="di-label">提交时间</div><div class="di-value">{{ detail.docSubmitTime || detail.regTime || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">审核时间</div><div class="di-value">{{ detail.docReviewTime || detail.activateTime || '--' }}</div></div>
        </div>
        <!-- 审核弹窗左侧已经常驻三张证件图，再铺一遍是重复的，只留一行指引 -->
        <div v-if="showDocImages" class="thumb-row">
          <div v-for="item in docImages" :key="item.label" class="thumb-cell">
            <div class="doc-thumb" @click="previewUrl(item.url, item.label)">
              <img v-if="item.url" :src="item.url" alt="">
              <span v-else>{{ item.icon }}</span>
            </div>
            <div class="doc-thumb-label">{{ item.label }}</div>
          </div>
        </div>
        <div v-else class="doc-hint">证件正反面/手持证件照片见左侧「申请资料」</div>
      </div>
    </el-tab-pane>

    <!-- 问卷调查 -->
    <el-tab-pane label="问卷调查" name="survey">
      <template v-if="surveyAnswer && surveyAnswer.answersJson">
        <div class="survey-head">
          <div style="display:flex;align-items:center;gap:10px;">
            <div class="survey-icon">📋</div>
            <div>
              <div style="font-size:14px;font-weight:600;color:#303133;">通用模版问卷</div>
              <div style="font-size:12px;color:#909399;margin-top:2px;">已完成</div>
            </div>
          </div>
          <el-button type="primary" size="small" @click="$emit('view-survey')">查看问卷结果</el-button>
        </div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">问卷模板</div><div class="di-value">通用模版问卷</div></div>
          <div class="detail-item"><div class="di-label">问卷版本</div><div class="di-value">{{ surveyAnswer.surveyVersion || 'v1.0' }}</div></div>
          <div class="detail-item"><div class="di-label">完成时间</div><div class="di-value">{{ surveyAnswer.completeTime || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">得分</div><div class="di-value" style="font-weight:600;color:#00897b;">{{ surveyAnswer.totalScore || 0 }}分</div></div>
          <div class="detail-item"><div class="di-label">风险等级</div><div class="di-value"><span class="survey-risk">{{ surveyAnswer.riskLevel || '--' }}</span></div></div>
          <div class="detail-item"><div class="di-label">关键题结果</div><div class="di-value">{{ surveyAnswer.keyResult || '--' }}</div></div>
        </div>
      </template>
      <div v-else class="empty-block">暂无问卷记录</div>
    </el-tab-pane>

    <!-- 银行卡 -->
    <el-tab-pane label="银行卡" name="bank">
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">
        <div v-for="card in (detail.bankCards || [])" :key="card.id" class="bank-card">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
            <div style="font-size:14px;font-weight:600;color:#303133;">{{ card.bankName }}</div>
            <span :style="verifyStatusBadgeStyle(card.status)">{{ verifyStatusLabel(card.status) }}</span>
          </div>
          <div class="mono" style="font-size:13px;color:#303133;margin-bottom:8px;letter-spacing:1px;">{{ card.bankAccount }}</div>
          <div style="font-size:11px;color:#909399;margin-bottom:4px;">持卡人：{{ card.bankHolder }}</div>
          <div style="font-size:11px;color:#909399;margin-bottom:4px;">{{ card.branch || '--' }} · {{ card.countryCode || '--' }}</div>
          <div style="font-size:11px;color:#606266;margin-bottom:2px;">
            <span v-if="card.bankCode">银行编码: {{ card.bankCode }}</span>
            <span v-if="card.bankCode && card.bankSwift" style="margin:0 8px;">|</span>
            <span v-if="card.bankSwift">SWIFT: {{ card.bankSwift }}</span>
            <span v-if="card.bankSwift && card.bankIban" style="margin:0 8px;">|</span>
            <span v-if="card.bankIban">IBAN: {{ card.bankIban }}</span>
          </div>
          <div v-if="card.bankSortCode" style="font-size:11px;color:#606266;margin-bottom:4px;">Sort Code: {{ card.bankSortCode }}</div>
          <div style="font-size:11px;color:#909399;">绑定时间：{{ card.bindTime || '--' }}</div>
        </div>
        <div v-if="!(detail.bankCards || []).length" class="empty-block" style="grid-column:span 2;">暂无银行卡记录</div>
      </div>
    </el-tab-pane>

    <!-- 审核信息：OCR比对 + 风险与设备环境 + 审核记录 -->
    <el-tab-pane label="审核信息" name="audit">
      <div class="tab-block">
        <div class="detail-sec-title">OCR与数据比对</div>
        <table style="width:100%;border-collapse:collapse;font-size:13px;border:1px solid #ebeef5;">
          <thead>
            <tr style="background:#f5f7fa;">
              <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">字段</th>
              <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">OCR提取</th>
              <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">用户填写</th>
              <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">后端比对</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in ocrRows" :key="r.field">
              <td style="padding:8px 12px;border:1px solid #ebeef5;">{{ r.field }}</td>
              <td style="padding:8px 12px;border:1px solid #ebeef5;color:#c0c4cc;">{{ r.ocr }}</td>
              <td style="padding:8px 12px;border:1px solid #ebeef5;">{{ r.user }}</td>
              <td style="padding:8px 12px;border:1px solid #ebeef5;">
                <el-tag :type="r.match ? 'success' : 'danger'" size="mini">{{ r.match ? '一致' : '不一致' }}</el-tag>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="display:flex;gap:16px;margin-top:8px;font-size:12px;">
          <span style="color:#909399;">OCR状态: <el-tag :type="ocrRows.length && ocrRows[0].match ? 'success' : 'warning'" size="mini">{{ ocrRows.length && ocrRows[0].match ? '已识别' : '未识别' }}</el-tag></span>
          <span style="color:#909399;">是否需审核: <el-tag :type="detail.needReview ? 'primary' : 'info'" size="mini">{{ detail.needReview ? '是' : '否' }}</el-tag></span>
        </div>
      </div>
      <div class="tab-block">
        <div class="detail-sec-title">风险与设备环境</div>
        <div class="risk-cards">
          <div v-if="detail.factorServiceName" class="risk-card"><span class="risk-icon">🪪</span><div><div class="risk-label">{{ detail.factorServiceName || '证件信息' }}</div><div class="risk-val"><el-tag type="success" size="mini">已识别</el-tag></div></div></div>
          <div v-if="detail.ocrServiceName" class="risk-card"><span class="risk-icon">🔍</span><div><div class="risk-label">{{ detail.ocrServiceName }}</div><div class="risk-val"><el-tag type="success" size="mini">已识别</el-tag></div></div></div>
          <div class="risk-card"><span class="risk-icon">🛡️</span><div><div class="risk-label">风控标签</div><div class="risk-val"><el-tag :type="detail.riskTags ? 'warning' : 'success'" size="mini">{{ detail.riskTags || '--' }}</el-tag></div></div></div>
        </div>
        <div style="font-size:13px;color:#606266;line-height:2;">
          <div><span style="color:#909399;">IP归属地:</span> {{ detail.ipRegion || '-' }}</div>
          <div><span style="color:#909399;">IP地址:</span> {{ detail.regIp || '-' }}</div>
          <div><span style="color:#909399;">手机归属地:</span> {{ detail.phoneRegion || '-' }}</div>
          <div><span style="color:#909399;">证件归属地:</span> {{ detail.idCardRegion || '-' }}</div>
          <div><span style="color:#909399;">设备指纹:</span> {{ detail.deviceFingerprint || '-' }}</div>
          <div>
            <span style="color:#909399;">设备黑名单:</span> <el-tag type="success" size="mini">正常</el-tag>
            <span style="margin-left:8px;color:#909399;">IP黑名单:</span> <el-tag type="success" size="mini">正常</el-tag>
          </div>
          <div><span style="color:#909399;">命中规则:</span> 无</div>
        </div>
      </div>
      <!-- 审核弹窗里正在做这一次审核，历史审核记录不展示（详情弹窗照常显示） -->
      <div v-if="showAuditLog" class="tab-block">
        <div class="detail-sec-title">审核记录</div>
        <div style="position:relative;padding-left:20px;border-left:2px solid #67c23a;">
          <div v-for="(log, i) in (detail.auditLogs || [])" :key="i" :style="{marginBottom: i<(detail.auditLogs||[]).length-1?'16px':'0', position:'relative'}">
            <div style="position:absolute;left:-25px;width:10px;height:10px;border-radius:50%;background:#67c23a;border:2px solid #fff;"></div>
            <div style="font-size:13px;font-weight:500;">{{ log.operator || '系统' }} <el-tag :type="log.action.includes('通过')?'success':log.action.includes('拒绝')?'danger':'primary'" size="mini">{{ log.action }}</el-tag></div>
            <div style="font-size:11px;color:#909399;margin-top:2px;">{{ log.operateTime }}</div>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { codeToText } from 'element-china-area-data'

export default {
  name: 'CustomerInfoTabs',
  props: {
    // 申请/客户详情（两处都来自 /business/accountApply/detail）
    detail: { type: Object, required: true },
    // 问卷答案（单独接口 accountApplySurveyAnswer，可能为 null）
    surveyAnswer: { type: Object, default: null },
    // 国家列表，用于国家代码转名称
    countries: { type: Array, default: () => [] },
    // 客户组列表，用于客户组ID转名称
    groups: { type: Array, default: () => [] },
    // 证件三张图：详情弹窗自己展示；审核弹窗左侧已常驻，传 false 不重复铺图
    showDocImages: { type: Boolean, default: true },
    // 审核记录：审核弹窗里正在做本次审核，传 false 隐藏「审核记录」时间线
    showAuditLog: { type: Boolean, default: true }
  },
  data() {
    return { tab: 'apply' }
  },
  computed: {
    // 当前居住地址（后端按 isCurrent 倒序返回，取第一条）
    currentAddress() { return (this.detail.addresses && this.detail.addresses[0]) || null },
    // 证件三张图
    docImages() {
      return [
        { label: '证件正面', icon: '🪪', url: this.detail.frontImageUrl },
        { label: '证件反面', icon: '🪪', url: this.detail.backImageUrl },
        { label: '手持证件', icon: '👤', url: this.detail.handheldImageUrl }
      ]
    },
    // OCR 比对行（与申请详情原有口径一致）
    ocrRows() {
      const d = this.detail
      return [
        { field: '姓名', ocr: '-', user: d.name || '-', match: false },
        { field: '号码', ocr: '-', user: d.docNumber || '---', match: false }
      ]
    }
  },
  watch: {
    // 换一条申请要回到第一个 Tab，否则会停在上一条看过的 Tab 上
    'detail.id'() { this.tab = 'apply' }
  },
  methods: {
    countryLabel(c) {
      const f = this.countries.find(x => x.countryCode === c)
      return f ? (f.countryCname || f.countryName) : (c || '--')
    },
    groupLabel(id) {
      const g = this.groups.find(x => x.id === id)
      return g ? g.groupName : (id || '--')
    },
    regLabel(v) { const m = { 1: 'H5', 2: 'Android', 3: 'IOS', 4: 'PC' }; return m[v] || '--' },
    docTypeLabel(t) { const m = { 1: '身份证', 2: '护照', 3: '驾驶证', 4: '居留许可' }; return m[t] || '--' },
    proofTypeLabel(t) { const m = { 1: '水电账单', 2: '银行账单', 3: '政府信函', 4: '居住证', 5: '燃气账单' }; return m[t] || '--' },
    docStatusLabel(s) { const m = { 1: '未认证', 2: '审核中', 3: '已认证', 4: '已拒绝' }; return m[s] || '--' },
    docStatusColor(s) { return s === 3 ? '#16a34a' : s === 4 ? '#dc2626' : '#e6a817' },
    verifyStatusLabel(s) { const m = { 1: '未认证', 2: '审核中', 3: '已认证', 4: '已拒绝' }; return m[s] || '--' },
    // 银行卡状态徽标取色：未认证(1)/已认证(3)=绿、审核中(2)=橙、已拒绝(4)=红
    verifyStatusBadgeStyle(s) {
      const color = s === 2 ? '#e6a23c' : s === 4 ? '#dc2626' : '#16a34a'
      return { background: this.colorAlpha(color, 0.12), color: color, fontSize: '11px', padding: '2px 8px', borderRadius: '4px' }
    },
    // 标签颜色后端存的是十六进制或 rgba() 两种格式，统一转成带透明度的 rgba
    colorAlpha(c, alpha) {
      const color = String(c == null ? '' : c).trim()
      let m = /^#([0-9a-f]{3})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h[0]+h[0],16)}, ${parseInt(h[1]+h[1],16)}, ${parseInt(h[2]+h[2],16)}, ${alpha})` }
      m = /^#([0-9a-f]{6})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h.slice(0,2),16)}, ${parseInt(h.slice(2,4),16)}, ${parseInt(h.slice(4,6),16)}, ${alpha})` }
      m = /^rgba?\(([^)]+)\)$/i.exec(color)
      if (m) { const p = m[1].split(','); return `rgba(${p[0]}, ${p[1]}, ${p[2]}, ${alpha})` }
      return `rgba(90, 101, 120, ${alpha})`
    },
    /** DB码(43/4313/431322)转中文名称(湖南省/娄底市/新化县) */
    areaLabel(addr) {
      if (!addr) return '--'
      const region = (codeToText[addr.province] || '') + (codeToText[addr.city] || '') + (codeToText[addr.district] || '')
      return (region + (addr.address || '')).replace(/\s+/g, '') || '--'
    },
    // 图片预览：没有地址就提示未上传，有就新窗口打开原图
    previewUrl(url, label) {
      if (!url) return this.$message.info('暂未上传' + (label || '文件'))
      window.open(url)
    }
  }
}
</script>

<style scoped>
.tab-block + .tab-block { margin-top: 16px; }
.detail-sec-title{font-size:14px;font-weight:600;color:#303133;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #ebeef5;}
.detail-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px 20px;}
.detail-item{display:flex;flex-direction:column;gap:3px;}
.di-label{font-size:11px;color:#909399;}
.di-value{font-size:13px;color:#303133;word-break:break-word;}
.detail-span-3{grid-column:span 3;}
.mono{font-family:'JetBrains Mono',Menlo,monospace;}
.avatar-circle{width:40px;height:40px;border-radius:50%;background:linear-gradient(135deg,var(--brand-primary-hover,#2b7de9),var(--brand-primary,#1f6fe0));color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:18px;object-fit:cover;}
/* 地址证明/证件三张图的缩略图（点击看原图） */
.thumb-row{margin-top:14px;display:flex;gap:16px;}
.thumb-cell{width:120px;}
.doc-thumb{width:120px;height:80px;border:1px solid #d1d9e6;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:20px;background:#f4f6fb;overflow:hidden;cursor:pointer;}
.doc-thumb:hover{border-color:var(--brand-primary);}
.doc-thumb img{width:100%;height:100%;object-fit:cover;}
.doc-thumb-label{width:120px;font-size:11px;color:#9ca3af;margin-top:4px;text-align:center;}
.doc-hint{margin-top:12px;font-size:12px;color:#909399;}
.empty-block{text-align:center;padding:40px;color:#9ca3af;font-size:13px;}
.survey-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;}
.survey-icon{width:40px;height:40px;border-radius:8px;background:linear-gradient(135deg,rgba(0,137,123,0.12),rgba(0,137,123,0.06));display:flex;align-items:center;justify-content:center;font-size:20px;}
.survey-risk{background:rgba(0,137,123,0.12);color:#00897b;font-size:11px;padding:2px 8px;border-radius:4px;}
.bank-card{border:1px solid #ebeef5;border-radius:10px;padding:16px;background:#f5f7fa;}
.risk-cards{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;margin-bottom:10px;}
.risk-card{padding:12px;border:1px solid #ebeef5;border-radius:8px;display:flex;align-items:center;gap:10px;}
.risk-icon{font-size:20px;}
.risk-label{font-size:12px;color:#909399;}
.risk-val{font-size:13px;font-weight:500;}
</style>
